/** أسماء الصلاحيات المستخدمة في الفرونت (تطابق حقل name من الـ API) */
export const PERMISSIONS = {
  USERS_VIEW: "users.view",
  USERS_CREATE: "users.create",
  USERS_EDIT: "users.edit",
  USERS_DELETE: "users.delete",
  USERS_CHANGE_PASSWORD: "users.change_password",
  USERS_ACTIVATE: "users.activate",

  ROLES_VIEW: "roles.view",
  ROLES_CREATE: "roles.create",
  ROLES_EDIT: "roles.edit",
  ROLES_DELETE: "roles.delete",

  PERMISSIONS_VIEW: "permissions.view",
  PERMISSIONS_CREATE: "permissions.create",
  PERMISSIONS_DELETE: "permissions.delete",

  ACTIVITIES_VIEW: "activities.view",
  ACTIVITIES_CREATE: "activities.create",
  ACTIVITIES_EDIT: "activities.edit",
  ACTIVITIES_DELETE: "activities.delete",

  FACILITY_TYPES_VIEW: "facility_types.view",
  FACILITY_TYPES_CREATE: "facility_types.create",
  FACILITY_TYPES_EDIT: "facility_types.edit",
  FACILITY_TYPES_DELETE: "facility_types.delete",

  PRICE_SURVEY_CATEGORIES_VIEW: "price_survey_categories.view",
  PRICE_SURVEY_CATEGORIES_CREATE: "price_survey_categories.create",
  PRICE_SURVEY_CATEGORIES_EDIT: "price_survey_categories.edit",
  PRICE_SURVEY_CATEGORIES_DELETE: "price_survey_categories.delete",

  PRICE_SURVEY_PRODUCTS_VIEW: "price_survey_products.view",
  PRICE_SURVEY_PRODUCTS_CREATE: "price_survey_products.create",
  PRICE_SURVEY_PRODUCTS_EDIT: "price_survey_products.edit",
  PRICE_SURVEY_PRODUCTS_DELETE: "price_survey_products.delete",

  VIOLATION_TYPES_VIEW: "violation_types.view",
  VIOLATION_TYPES_CREATE: "violation_types.create",
  VIOLATION_TYPES_EDIT: "violation_types.edit",
  VIOLATION_TYPES_DELETE: "violation_types.delete",

  PATROL_STAFF_VIEW: "patrol_staff.view",
  PATROL_STAFF_CREATE: "patrol_staff.create",
  PATROL_STAFF_EDIT: "patrol_staff.edit",
  PATROL_STAFF_DELETE: "patrol_staff.delete",

  LOCATIONS_VIEW: "locations.view",
  LOCATIONS_CREATE: "locations.create",
  LOCATIONS_EDIT: "locations.edit",
  LOCATIONS_DELETE: "locations.delete",

  GENERATE_UID_VIEW: "generate_uid.view",
  GENERATE_UID_CREATE: "generate_uid.create",
  GENERATE_UID_EXPORT_PDF: "generate_uid.export_pdf",

  COMPLAINT_CATEGORIES_VIEW: "complaint_categories.view",
  COMPLAINT_CATEGORIES_CREATE: "complaint_categories.create",
  COMPLAINT_CATEGORIES_EDIT: "complaint_categories.edit",
  COMPLAINT_CATEGORIES_DELETE: "complaint_categories.delete",
};

const STORAGE_KEY = "permissions";

export function extractPermissionNames(userOrPermissions) {
  if (Array.isArray(userOrPermissions)) {
    return userOrPermissions
      .map((p) => (typeof p === "string" ? p : p?.name))
      .filter(Boolean);
  }
  const list = userOrPermissions?.permissions;
  if (!Array.isArray(list)) return [];
  return list.map((p) => p?.name).filter(Boolean);
}

export function savePermissions(userOrPermissions) {
  const names = extractPermissionNames(userOrPermissions);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(names));
  return names;
}

export function clearPermissions() {
  localStorage.removeItem(STORAGE_KEY);
}

export function getPermissions() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
    // ترحيل من جلسة قديمة قبل تخزين permissions منفصلاً
    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const names = extractPermissionNames(JSON.parse(userRaw));
      if (names.length) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(names));
        return names;
      }
    }
    return [];
  } catch {
    return [];
  }
}

/** هل يملك المستخدم صلاحية معيّنة؟ */
export function can(permission) {
  if (!permission) return true;
  return getPermissions().includes(permission);
}

export function canAny(permissions = []) {
  if (!permissions.length) return true;
  return permissions.some((p) => can(p));
}

export function canAll(permissions = []) {
  if (!permissions.length) return true;
  return permissions.every((p) => can(p));
}
